import { z } from 'zod';
import { DeviceGenre } from '@/features/device/genre/type';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { CategoryKey, TabKey } from './constants';
import { DEVICE_INVENTORY_SORT_COLUMNS, isDeviceInventorySortColumn } from './utils/isDeviceInventorySortColumn';
export { isDeviceInventorySortColumn };
export const SearchSchema = z.object({
  ...dataGridSearchFields,
  sortColumn: z.enum(DEVICE_INVENTORY_SORT_COLUMNS).optional(),
  menu: z.nativeEnum(TabKey).default(TabKey.ALL),
  category: z.nativeEnum(CategoryKey).default(CategoryKey.ALL),
  genres: z.array(z.nativeEnum(DeviceGenre)).optional(),
  freeText: z.string().optional(),
  placementPlaceIds: z.array(z.string()).optional(),
  warehousingPlaceIds: z.array(z.string()).optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;